<template>
  <div class="out-header-countdown">
    <p class="out-header-countdown-text">12月31日 19-24点</p>
    <p class="out-header-countdown-txt">整点红包雨,六场连发</p>
  </div>
  <div class="out-header-btn">
    <p>提醒我</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'OutHeader',
  props: ['time']
})
</script>

<style lang="scss">
.out-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 15px;
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 0.06);

  &-countdown {
    display: flex;
    align-items: center;

    &-txt {
      position: relative;
      top: -1px;
      font-family: TTTGB;
      font-size: 12px;
      font-weight: 500;
      color: #ff4c4c;
      margin-left: 10px;
    }
  }

  &-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 20px;
    border-radius: 10px;
    color: #fff;
    background-image: linear-gradient(to left, #cf2c38, #fa434f 0%);
    font-size: 12px;
  }
}
</style>
